export const PASSWORD_RESET_SET = 'PASSWORD_RESET_SET'
export const PASSWORD_RESET_LOAD = 'PASSWORD_RESET_LOAD'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_FAILED = 'PASSWORD_RESET_FAILED'
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR'
